<div class="performance-container" [class.expanded]="isHovered">
  <div class="table-container scroll-bar">
    <table
      class="mat-elevation-z8 printable-table"
      #table
      id="style-4"
      matSort
      [ngClass]="{ 'dark-table': isDarkMode() }"
    >
      <thead class="sticky-header">
        <tr>
          <th class="th-text-center2" mat-sort-header="sNo" rowspan="2">
            S.No
          </th>
          <th class="th-text-center3" mat-sort-header="shipName" rowspan="2">
            Ship Name
          </th>
          <th class="th-text-center2" mat-sort-header="imoNumber" rowspan="2">
            I.M.O Number
          </th>
          <th class="th-text-center" mat-sort-header="segment" rowspan="2">
            Segment
          </th>
          <th class="th-text-center2" mat-sort-header="timeLost" rowspan="2">
            <span class="info">
              Time(Hrs)<mat-icon
                class="info"
                matTooltip="loss in red gain in green"
                >info</mat-icon
              ><br />
              Lost(-) or Gained(+)</span
            >
          </th>
          <th colspan="3">
            <span class="header-show info1">
              Bunker Lost(-) or Gained(mt)<mat-icon
                class="info"
                matTooltip="loss in red gain in green"
                >info</mat-icon
              >
            </span>
          </th>
          <th rowspan="2">Average Speed</th>
        </tr>
        <tr>
          <th class="th-text-center2" mat-sort-header="hsfo">
            <span>HSFO</span>
          </th>
          <th class="th-text-center2" mat-sort-header="vlsfo">
            <span>VLSFO</span>
          </th>
          <th class="th-text-center2" mat-sort-header="go"><span>GO</span></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let element of elements; let rowIndex = index">
          <td>
            {{ element.sNo }}
          </td>
          <td class="fixed-col">{{ element.shipName }}</td>
          <td>{{ element.imoNumber }}</td>
          <td>{{ element.segment }}</td>
          <td
            [ngStyle]="{
              color:
                element.timeLost < 0
                  ? '#ff9090'
                  : element.timeLost > 0
                    ? '#a8d296'
                    : 'null',
            }"
          >
            {{ element.timeLost }}
          </td>
          <td
            [ngStyle]="{
              color:
                element.bunkerLostOrGain.HSFO < 0
                  ? '#ff9090'
                  : element.bunkerLostOrGain.HSFO > 0
                    ? '#a8d296'
                    : 'null',
            }"
          >
            {{ element.bunkerLostOrGain.HSFO }}
          </td>
          <td
            [ngStyle]="{
              color:
                element.bunkerLostOrGain.VLSFO < 0
                  ? '#ff9090'
                  : element.bunkerLostOrGain.VLSFO > 0
                    ? '#a8d296'
                    : 'null',
            }"
          >
            {{ element.bunkerLostOrGain.VLSFO }}
          </td>
          <td
            [ngStyle]="{
              color:
                element.bunkerLostOrGain.GO < 0
                  ? '#ff9090'
                  : element.bunkerLostOrGain.GO > 0
                    ? '#a8d296'
                    : 'null',
            }"
          >
            {{ element.bunkerLostOrGain.GO }}
          </td>
          <td>{{ element.avg_speed_in_gw }}</td>
        </tr>
      </tbody>
    </table>
  </div>
  <mat-paginator
    [length]="length"
    [pageSizeOptions]="[]"
    [pageSize]="itemsPerPage"
    [disabled]="isLoadingPage"
    (page)="onPageChange($event)"
    [hidePageSize]="true"
    showFirstLastButtons
    [ngClass]="{ 'dark-paginator': isDarkMode() }"
  ></mat-paginator>
  <br>
</div>
